<template>
  <div class="widget widget--dobrodelen">
    <div :class="{ widget__blurred: shouldShowSignatureForm }">
      <header class="widget__header">
        <h1>Nič vas ne stane, če ste <span>dobrodelni</span>.</h1>
      </header>
      <div class="widget__content__container">
        <div class="widget__content pb-0">
          <h2>Zahteva za namenitev dela dohodnine za donacije</h2>
          <p class="widget__text-small mb-0">
            Vsi davčni zavezanci imate možnost odločanja o svoji dohodnini. <strong>Do 1&nbsp;%</strong> lahko namenite eni izmed organizacij s seznama
            upravičencev do donacije dohodnine.
          </p>
        </div>
      </div>
      <div class="widget__content__container">
        <div class="widget__content">
          <div class="widget__ngo">
            <h2>Podatki o upravičencu</h2>
            <div class="widget__form">
              <div class="form-controls row">
                <div class="col-xs-12">
                  <input class="form-control" :value="name" readonly>
                </div>
                <div class="col-xs-12">
                  <input class="form-control" :value="address" readonly>
                </div>
                <div class="col-xs-4">
                  <input class="form-control" :value="postalCode" readonly>
                </div>
                <div class="col-xs-8">
                  <input class="form-control" :value="city" readonly>
                </div>
                <div class="col-xs-12">
                  <div class="form-inline-container">
                    <div class="form-inline">
                      <label class="tax-label">Davčna številka</label>
                      <div class="control-container control-container--tax">
                        <input class="form-control" maxlength="1" :value="taxNumberArray[0]" readonly>
                        <input class="form-control" maxlength="1" :value="taxNumberArray[1]" readonly>
                        <input class="form-control" maxlength="1" :value="taxNumberArray[2]" readonly>
                        <input class="form-control" maxlength="1" :value="taxNumberArray[3]" readonly>
                        <input class="form-control" maxlength="1" :value="taxNumberArray[4]" readonly>
                        <input class="form-control" maxlength="1" :value="taxNumberArray[5]" readonly>
                        <input class="form-control" maxlength="1" :value="taxNumberArray[6]" readonly>
                        <input class="form-control" maxlength="1" :value="taxNumberArray[7]" readonly>
                      </div>
                    </div>
                    <div class="form-inline">
                      <label class="percent-label">Odstotek</label>
                      <div class="control-container control-container--percent">
                        <input class="form-control" :value="percent === '1.0' ? '1' : percent" readonly>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="widget__content">
          <div class="widget__person">
            <h2>Podatki o davčnem zavezancu</h2>
            <div class="widget__form">
              <div class="form-controls row">
                <div class="col-xs-12">
                  <input class="form-control" placeholder="Ime oz. naziv upravičenca" v-model="input.name">
                </div>
                <div class="col-xs-12">
                  <input class="form-control" placeholder="Naselje, ulica, hišna številka" v-model="input.address">
                </div>
                <div class="col-xs-4">
                  <input class="form-control" placeholder="Poštna št." v-model="input.postalCode">
                </div>
                <div class="col-xs-8">
                  <input class="form-control" placeholder="Pošta" v-model="input.city">
                </div>
                <div class="col-xs-12 form-inline">
                  <label>Davčna številka</label>
                  <div class="control-container control-container--tax">
                    <input class="form-control" maxlength="1" v-model="input.taxArray[0]" @input="focusNext">
                    <input class="form-control" maxlength="1" v-model="input.taxArray[1]" @input="focusNext">
                    <input class="form-control" maxlength="1" v-model="input.taxArray[2]" @input="focusNext">
                    <input class="form-control" maxlength="1" v-model="input.taxArray[3]" @input="focusNext">
                    <input class="form-control" maxlength="1" v-model="input.taxArray[4]" @input="focusNext">
                    <input class="form-control" maxlength="1" v-model="input.taxArray[5]" @input="focusNext">
                    <input class="form-control" maxlength="1" v-model="input.taxArray[6]" @input="focusNext">
                    <input class="form-control" maxlength="1" v-model="input.taxArray[7]">
                  </div>
                </div>
                <div class="col-xs-12 form-inline">
                  <label>Kontaktni podatki</label>
                </div>
                <div class="col-xs-6">
                  <input class="form-control" placeholder="Elektronski naslov" v-model="input.email">
                </div>
                <div class="col-xs-6">
                  <input class="form-control" placeholder="Telefonska številka" v-model="input.phone">
                </div>
              </div>
            </div>
            <p class="widget__text-small" style="margin-top: 10px; margin-bottom: 0;">

            </p>
          </div>
        </div>
      </div>
      <div class="widget__footer">
        <div class="widget__content__container">
          <div class="widget__content">
            <p class="widget__text-small">
              Ko boste izpolnili obrazec, imate dve možnosti:
            </p>
            <ol class="widget__text-small">
              <li>
                Če želite podatke sami posredovati Fursu, boste prejeli PDF datoteko. To natisnete in posredujete Fursu. V tem primeru ne shranjujemo
                nobenih vaših podatkov.
              </li>
              <li>
                Lahko pa vse uredite elektronsko ter tiskanje in pošiljanje prepustite CNVOS. Obrazce bodo posredovali Fursu vsakega 28. v mesecu, razen
                decembra že 20. v mesecu. CNVOS bo vaše podatke izbrisal dan po tem, ko bodo vaš obrazec poslali Fursu. Več o splošnih pogojih uporabe in
                obdelavi osebnih podatkov pri CNVOS si preberite <a href="https://www.cnvos.si/nvo-vseved/enprocent/splosni-pogoji/" target="_blank">tukaj</a>.
              </li>
            </ol>
            <!-- <p class="widget__link widget__text-small">
              Več informacij na <a href="https://www.cnvos.si/enprocent/" target="_blank">cnvos.si/enprocent</a>
            </p> -->
            <div class="widget__buttons-container">
              <div class="widget__button-container">
                <a :href="linkToPDF" download="obrazec_enprocent.pdf" target="_blank" class="btn btn-primary btn-sm" :disabled="inputHasErrors" @click="onLinkToPDFClick">
                  <i class="glyphicon glyphicon-download-alt"></i> Prenesi in pošlji obrazec sam
                </a>
              </div>
              <div class="widget__button-container">
                <button v-if="showSendToCnvosButton" download="obrazec_enprocent.pdf" target="_blank" class="btn btn-primary btn-sm" :disabled="inputHasErrors" @click.prevent="showSignatureForm">
                  <i class="glyphicon glyphicon-pencil"></i> Podpiši in posreduj CNVOS-u
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="shouldShowSignatureForm" class="widget__overlay">
      <div class="widget__signature__content">
        <template v-if="!signedPdfSubmitted">
          <signature-pad :key="signaturePadKey" @ready="onSignatureReady" @change="onSignatureChange" />
          <div class="text-center">
            <button class="btn btn-link btn-sm" style="padding:0" type="button" @click.prevent="resetSignature">Izbriši podpis</button>
          </div>
          <div class="widget__signature__button">
            <button class="btn btn-primary" type="button" :disabled="signatureFormHasErrors || pdfSubmitting" @click.prevent="onSubmitPDF">
              Potrdi in posreduj obrazec CNVOS-u
            </button>
          </div>
        </template>
        <template v-else>
          <p class="text-center" style="margin-top: 3rem; font-weight: 700;">
            Hvala, prejeli smo vaš obrazec. Če imate kakršna koli vprašanja, nam pišite na <a href="mailto:info@cnvos.si" target="_blank">info@cnvos.si</a>.
          </p>
          <!-- This button doesnt work because url lenght is too long for gunicorn if GET is used, and we can't POST in iframes in safari -->
          <!-- <p class="text-center question__button">
            <a :href="linkToPDF" download="obrazec_enprocent.pdf" target="_blank" class="btn btn-primary btn-sm" :disabled="signatureFormHasErrors || pdfSubmitting">
              <i class="glyphicon glyphicon-download-alt"></i> Prenesi kopijo obrazca
            </a>
          </p> -->
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import SignaturePad from './SignaturePad.vue';

export default {
  name: 'widget',
  components: {
    SignaturePad,
  },
  data() {
    return {
      input: {
        name: '',
        address: '',
        postalCode: '',
        city: '',
        taxArray: [],
        email: '',
        phone: '',
      },
      signaturePadKey: 1,
      shouldShowSignatureForm: false,
      signatureFormHasErrors: true,
      signatureDataUrl: null,
      signedPdfSubmitted: false,
      pdfSubmitting: false,
    };
  },
  mounted() {
    const s = document.createElement('script');
    s.src = 'https://cdnjs.cloudflare.com/ajax/libs/iframe-resizer/4.3.2/iframeResizer.contentWindow.min.js';
    document.body.appendChild(s);
  },
  watch: {
    'input.postalCode': function handler(newVal) {
      if (newVal && newVal.length === 4) {
        $.getJSON(`/enprocent/getFURS/${newVal}/`).done((data) => {
          this.input.city = data.city;
        });
      }
    },
  },
  computed: {
    taxNumberArray() {
      if (this.taxNumber && this.taxNumber.length === 8) {
        return this.taxNumber.split('');
      }
      return [0, 0, 0, 0, 0, 0, 0, 0];
    },
    inputTaxNumber() {
      return this.input.taxArray.join('');
    },
    linkToPDF() {
      const selected = `${this.name}|=|${this.taxNumber}|=|${this.percent}`;

      let url = `/pdf/genPDFfromPOST/?template=dobrodelen_pdf&filename=obrazec_enprocent`;
      url += `&source_domain=${encodeURIComponent(this.sourceDomain)}`;
      if (this.signedPdfSubmitted) {
        url += `&skip_save=true`;
      }
      url += `&selected_orgs=${encodeURIComponent(selected)}`;
      url += `&name=${encodeURIComponent(this.input.name)}`;
      url += `&address=${encodeURIComponent(this.input.address)}`;
      url += `&postalCode=${encodeURIComponent(this.input.postalCode)}`;
      url += `&city=${encodeURIComponent(this.input.city)}`;
      url += `&taxNumber=${encodeURIComponent(this.inputTaxNumber)}`;
      url += `&email=${encodeURIComponent(this.input.email)}`;
      url += `&phone=${encodeURIComponent(this.input.phone)}`;
      if (this.signatureDataUrl) {
        url += `&signature=${encodeURIComponent(this.signatureDataUrl)}`;
      }

      return url;
    },
    inputHasErrors() {
      if (Object.keys(this.input).some(e => !this.input[e])) {
        return true;
      }
      if (this.input.name.trim().length < 3 || this.input.name.trim().indexOf(' ') === -1) {
        return true;
      }
      if (this.input.address.trim().length < 3) {
        return true;
      }
      if (!/^\d{4}$/.test(this.input.postalCode)) {
        return true;
      }
      if (this.input.city.trim().length < 2) {
        return true;
      }
      if (!/^\d{8}$/.test(this.inputTaxNumber)) {
        return true;
      }
      const phone = this.input.phone.replace(/\D/g, '');
      if (phone.length < 7) {
        return true;
      }
      if (!this.input.email.includes('@') || !this.input.email.includes('.')) {
        return true;
      }
      return false;
    },
    showSendToCnvosButton() {
      const now = new Date();
      const month = now.getMonth() + 1;
      if (month === 12) {
        return now.getDate() < 21;
      }
      return true;
    }
  },
  props: {
    name: { type: String, required: true },
    address: { type: String, required: true },
    postalCode: { type: String, required: true },
    city: { type: String, required: true },
    taxNumber: { type: String, required: true },
    percent: { type: String, required: true },
    sourceDomain: { type: String, required: true },
  },
  methods: {
    focusNext(event) {
      if (event.target && event.target.nextElementSibling && event.target.nextElementSibling.tagName === 'INPUT') {
        event.target.nextElementSibling.select();
      }
    },
    onLinkToPDFClick(event) {
      if (this.inputHasErrors) {
        event.preventDefault();
        return;
      }
    },
    showSignatureForm() {
      this.shouldShowSignatureForm = true;
    },
    onSignatureChange(pad) {
      this.signatureFormHasErrors = pad.isEmpty();
      this.signatureDataUrl = pad.toDataURL();
    },
    onSignatureReady(pad) {
      this.signatureFormHasErrors = true;
      this.signatureDataUrl = null;
      this.signedPdfSubmitted = false;
    },
    resetSignature() {
      this.signaturePadKey++;
    },
    onSubmitPDF(event) {
      this.pdfSubmitting = true;

      const selected = `${this.name}|=|${this.taxNumber}|=|${this.percent}`;

      const formData = new FormData();
      formData.append("template", "dobrodelen_pdf");
      formData.append("filename", "obrazec_enprocent");
      formData.append("source_domain", this.sourceDomain);
      if (this.signedPdfSubmitted) {
        formData.append("skip_save", "true");
      }
      formData.append("selected_orgs", selected);
      formData.append("name", this.input.name);
      formData.append("address", this.input.address);
      formData.append("postalCode", this.input.postalCode);
      formData.append("city", this.input.city);
      formData.append("taxNumber", this.inputTaxNumber);
      formData.append("email", this.input.email);
      formData.append("phone", this.input.phone);
      formData.append("signature", this.signatureDataUrl);

      $.ajax({
        url: '/pdf/genPDFfromPOST/',
        data: formData,
        processData: false,
        contentType: false,
        type: 'POST',
        success: (...args) => {
          this.signedPdfSubmitted = true;
          this.pdfSubmitting = false;
        }
      });
    }
  },
};
</script>

<style>
body {
  background-color: #f3ebee;
}

ol, li {
  margin: 0;
  padding: 0;
}

ol {
  margin-bottom: 10px;
}

ol li {
  padding-left: 0.5em;
  margin-left: 1.5em;
  margin-bottom: 5px;
}

.mb-0 {
  margin-bottom: 0 !important;
}
.pb-0 {
  padding-bottom: 0 !important;
}

.widget {
  background-color: #f8fafc;
  text-align: left;
  position: relative;
}

.widget__blurred {
  filter: blur(2px);
}

.widget__header,
.widget__footer {
  background-color: #f3ebee;
}

.widget__header {
  padding: 12px;
}

.widget__header h1 {
  font-size: 20px;
  line-height: 22px;
  color: #402631;
  font-weight: 500;
  margin-top: 5px;
  margin-bottom: 5px;
  text-align: center;
}

.widget__header h1 span {
  font-weight: 900;
}

.widget__content__container {
  display: flex;
  max-width: 800px;
  margin: 0 auto;
}

@media (max-width: 609.98px) {
  .widget__content__container {
    flex-direction: column;
  }
}

.widget__content {
  flex: 1;
  padding: 12px;
}

.widget__content .widget__footer {
  padding: 0;
}

.widget__content h2 {
  font-size: 16px;
  line-height: 20px;
  font-weight: 500;
  margin: 0 0 8px;
}

.widget__form .form-controls {
  padding: 0 12.5px;
}

.widget__form .form-controls>[class*='col-'] {
  padding-right: 2.5px;
  padding-left: 2.5px;
}

.widget__form .form-control {
  margin-bottom: 5px;
  color: #000;
  font-weight: 400;
}

.widget__form .form-control:read-only {
  cursor: default;
}

.widget__form .form-inline-container {
  display: flex;
  justify-content: space-between;
}

.widget__form .form-inline {
  display: flex;
  flex-direction: column;
}

.widget__form .form-inline label {
  display: inline-block;
  font-weight: 400;
  font-size: 12px;
  margin-top: 1px;
}

.widget__form .form-inline .control-container {
  float: right;
}

.widget__form .form-inline .control-container .form-control {
  width: 214px;
  float: left;
  padding-left: 8px;
}

.widget__form .form-inline .control-container--percent .form-control,
.widget__form .form-inline .control-container--tax .form-control {
  width: 25px;
  text-align: center;
  padding-left: 5px;
  padding-right: 5px;
}

.widget__form .form-inline .control-container--tax .form-control {
  margin-right: 2px;
}

.widget__form .form-inline .control-container--percent .form-control {
  width: 60px;
}

.widget__text-small {
  font-size: 10px;
  line-height: 1.4;
  font-weight: 400;
}

.widget__link a {
  text-decoration: none;
  font-weight: 500;
  color: #c29dac;
}

.widget__link a:hover {
  text-decoration: underline;
}

.widget__buttons-container {
  display: flex;
  justify-content: space-around;
}

.widget__buttons-container .widget__button-container {
  text-align: center;
}

@media (max-width: 609.98px) {
  .widget__buttons-container {
    flex-direction: column-reverse;
  }

  .widget__buttons-container .widget__button-container {
    margin-top: 10px;
  }
}

.widget__overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgb(248, 250, 252, 0.25);
  display: flex;
  align-items: center;
}

.widget__signature__content {
  width: 100%;
}

.widget__signature__content .signature-container {
  margin: 0 auto;
}

.widget__signature__button {
  margin-top: 10px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/dobrodelen/WidgetV2.vue